export default __webpack_public_path__ + "static/web_JS6-12af10a7f81830de7bf6165e0d131a88.jpg";